import React, { useEffect, useState } from "react";
import ModalBasic from "../ModalBasic";
import axios from "axios";
import _ from "lodash";
import { HEADER } from "../../utils/Utils";
import Select from "react-select";
import Banner from "../Banner/Banner";
import InputPhoneNumber from "../Input/InputPhoneNumber";

export default function ModalUser({
   showModal,
   setShowModal,
   modalUserDetails,
   inputUser,
   setInputUser,
   functionAdd,
   functionEdit,
   dataOutlet,
   validationUser,
}) {
   // initial variabel for validation
   validationUser = validationUser ?? {
      email: {
         validate: true,
         message: "",
      },
      phone: {
         validate: true,
         message: "",
      },
      general: {
         validate: true,
         message: "",
      },
   };

   const [outlets, setOutlets] = useState([]);

   useEffect(() => {
      GetDataOutlets();
      return () => {
         setOutlets([]);
      };
   }, []);

   async function GetDataOutlets() {
      try {
         let list_outlets = await axios.get(
            `${process.env.REACT_APP_BASE_URL_API}/outlet/kartini?channel_id=${dataOutlet.channel_id}`,
            { headers: HEADER }
         );
         list_outlets = list_outlets.data.data;
         setOutlets(
            list_outlets.map((outlet) => ({
               ...outlet,
               label: outlet.outlet_kartini_name,
               value: outlet.outlet_kartini_id,
            }))
         );
      } catch (error) {
         console.error(error);
      }
   }

   function handleChange(e) {
      setInputUser((prevState) => ({
         ...prevState,
         [e.target.name]: e.target.value,
      }));
   }

   return (
      <>
         {/* Modal ADD User */}
         <ModalBasic
            name="add_outlet_modal"
            modalOpen={showModal}
            setModalOpen={setShowModal}
            title={modalUserDetails.title}
            enClose={true}
         >
            <div className="px-5 pt-4 pb-1">
               <div className="space-y-3">
                  <input
                     name="user_name"
                     placeholder="User Name"
                     className="form-input w-full h-12"
                     type="text"
                     value={inputUser.user_name ?? ""}
                     onChange={(e) => handleChange(e)}
                  />
                  <div>
                     <input
                        name="user_email"
                        placeholder="User Email"
                        className={`form-input w-full h-12 ${
                           !validationUser.email.validate && "border-rose-500"
                        }`}
                        type="email"
                        value={inputUser.user_email ?? ""}
                        onChange={(e) => handleChange(e)}
                     />
                     {!validationUser.email.validate && (
                        <div className="text-xs mt-1 text-rose-500">
                           {validationUser.email.message}
                        </div>
                     )}
                  </div>
                  <InputPhoneNumber
                     phoneNumber={inputUser.user_mobile}
                     setPhoneNumber={setInputUser}
                     type="user_mobile"
                     validation={validationUser}
                  />
                  <div className="font-semibold text-gray-600 text-sm">
                     Asign To
                  </div>
                  <Select
                     className="col-span-full sm:col-span-2"
                     placeholder="Outlet Name"
                     options={outlets}
                     value={outlets.filter(
                        (option) => option.value === inputUser.outlet_kartini_id
                     )}
                     onChange={(e) =>
                        setInputUser((prevState) => ({
                           ...prevState,
                           outlet_kartini_id: e.value,
                        }))
                     }
                  />

                  <Banner
                     type="error"
                     open={!validationUser.general.validate}
                     enableClose={false}
                  >
                     {!validationUser.general.message}
                  </Banner>
               </div>
            </div>
            {/* Modal footer */}
            <div className="px-5 py-4">
               <div className="flex flex-wrap justify-end space-x-2">
                  <button
                     className="btn-sm border-gray-200 hover:border-gray-300 text-gray-600"
                     onClick={(e) => {
                        e.stopPropagation();
                        setShowModal(false);
                        setInputUser({});
                     }}
                  >
                     Close
                  </button>
                  <button
                     className="btn-sm bg-[#4CA6F8] text-white disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
                     onClick={(e) => {
                        e.stopPropagation();
                        if (modalUserDetails.type === "Add") {
                           functionAdd();
                        } else if (modalUserDetails.type === "Edit") {
                           functionEdit(inputUser);
                        }
                     }}
                     disabled={
                        !inputUser.user_email ||
                        !inputUser.user_name ||
                        !inputUser.outlet_kartini_id
                     }
                  >
                     {modalUserDetails.title}
                  </button>
               </div>
            </div>
         </ModalBasic>
      </>
   );
}
